// getTranslationKey.js
'use strict';
import { LRUCache } from 'lru-cache';

const cache = new LRUCache({ max: 256 });

/**
 * Get translation key.
 * @param {string} {key} - translation key.
 * @param {boolean} {[shouldUpperCase = false]} - should upper case the key.
 * @return {string|undefined} Return formatted translation key.
 */
const getTranslationKey = ({ key, shouldUpperCase = false } = {}) => {
  if (!key) {
    return;
  }
  const cacheKey = `${key}:${shouldUpperCase}`;
  let result = cache.get(cacheKey);
  if (result) {
    return result;
  }
  const replacedString = key.replace(/[^a-z\d]/gi, '_');
  result = shouldUpperCase
    ? replacedString.toUpperCase()
    : replacedString.toLowerCase();
  cache.set(cacheKey, result);
  return result;
};

export default getTranslationKey;
